export class MedicalLicense {
    constructor() {
       this.licenseNumber = null;
       this.medicalLicenseId = 0; 
    }
    public medicalLicenseId: number;
    public licenseNumber: string;
    public stateId: number;
    public expirationDate: string;
    public isNew: boolean;
    public isEditing: boolean;
    public validationMessage: string[];
}

